/* eslint-disable no-debugger */
import { ArrayExtensions, DeliveryMode } from '@msdyn365-commerce-modules/retail-actions';
import * as React from 'react';

import { IBuyboxCommonData, IProductDetails, IBuyboxState } from '@msdyn365-commerce-modules/buybox';
import { IProductInventoryInformation } from '../../../actions/product-inventory-information';
import { ILobasBuyboxProps } from '../lobas-buybox.props.autogenerated';

const _getClassNamePrefix = (typeName: string): string => {
    return typeName.toLocaleLowerCase() === 'quickview' ? 'ms-quickView' : 'ms-buybox';
};

export function getBuyBoxInventoryLabel(
    props: ILobasBuyboxProps<IBuyboxCommonData>,
    state?: IBuyboxState,
    productDetails?: IProductDetails
): React.ReactElement | undefined {
    const { typeName } = props;

    // Since the data action can return no value, and the type is non-nullable due to backward compatibility reasons, the null check is required.
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- Explicitly check for null/undefined.
    const productAvailableQuantity = props.data.productAvailableQuantity?.result ?? productDetails?.productAvailableQuantity;
    const productSelected = state?.selectedProduct;
    const className = _getClassNamePrefix(typeName);

    if (productSelected === undefined && (!productAvailableQuantity || !ArrayExtensions.hasElements(productAvailableQuantity))) {
        return (
            <div className={`${className}__inventory-info`}>
                <span className={`${className}__inventory-label`}>{props.resources.inventoryAvailability}</span>
            </div>
        );
    }
    if (!productAvailableQuantity || !ArrayExtensions.hasElements(productAvailableQuantity)) {
        return (
            <div className={`${className}__inventory-info`}>
                <span className={`${className}__inventory-label ${className}__inventory-code-oos`}>
                    {props.resources.inventoryOutOfStock}
                </span>
            </div>
        );
    }
    const shippingInventory = productAvailableQuantity.find(shipping => shipping.deliveryType === DeliveryMode.shipping);

    if (shippingInventory) {
        let inventoryClassName: string;
        if (shippingInventory.StockLevelCode) {
            inventoryClassName = `${className}__inventory-label ${className}__inventory-code-${shippingInventory.StockLevelCode.toLowerCase()}`;
        } else {
            inventoryClassName = `${className}__inventory-label`;
        }
        return (
            <div className={`${className}__inventory-info`}>
                <span className={inventoryClassName}>{shippingInventory.StockLevelLabel}</span>
                <span className={`${className}__inventoryQty-label`}>{getInventoryQty(shippingInventory)}</span>
            </div>
        );
    }

    return undefined;
}

const getInventoryQty = (inventory: IProductInventoryInformation): string => {
    if (inventory.ProductAvailableQuantity.AvailableQuantity && inventory.ProductAvailableQuantity.AvailableQuantity > 0) {
        const qtyAvailable = inventory.ProductAvailableQuantity.AvailableQuantity;
        let step = Math.log10(qtyAvailable);

        if (step - Math.floor(step) >= 0.69898) {
            step = Math.ceil(step);
        } else {
            step = Math.floor(step);
        }

        let denom = Math.floor(qtyAvailable / Math.pow(10, step));

        if (denom < 1) {
            denom = 0.5;
        }

        const qtyRange = denom * Math.pow(10, step);

        return `${qtyRange}+`;
    }
    return '';
};
